<template>
  <div v-if="stockItem">
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-2">{{ mdiHistory }}</v-icon>
          History
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Receiving Date: {{ formatDateTime(stockItem.deliveryNote.receivingDate) }}
        </v-card-title>

        <v-card-text>
          <!-- <p v-for="stockItemActivity in stockItemActivities" -->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-btn color="success" small :to="{
        name: 'processing-StockItemFiles',
        query: { stockItemId: stockItemId.id }
      }">

        Docs
      </v-btn>

  </div>
</template>

<script>
import { mdiHistory } from '@mdi/js';
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    stockItem: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      mdiHistory,
      dialog: false,
    };
  },
  computed: {
    ...mapState('stockItemActivities', ['stockItemActivities']),
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.LOAD_stockItemActivities(this.stockItem.id);
      }
    },
  },
  methods: {
    ...mapActions('stockItemActivities', ['LOAD_stockItemActivities']),
  },
};
</script>

<style lang="scss" scoped>

</style>
